<template>
  <div :class="componentClassName">
    <a-brand-logo variant="horizontal" class="t-walkthrough-complete__logo" />
    <div class="t-walkthrough-complete__content">
      <a-application-complete-sign class="t-walkthrough-complete__image" />
      <a-heading
        heading="初期設定が完了しました"
        color="primary"
        size="large"
        class="t-walkthrough-complete__heading"
      />
      <a-text class="t-walkthrough-complete__text">
        基本設定は以上です。<br />
        設定内容は、メニュー＞各項目の設定画面から確認・変更ができます。
      </a-text>
      <a-button
        variant="block"
        color="primary"
        label="ホーム画面へ"
        class="t-walkthrough-complete__button"
        @click="handleGoToHome"
      />
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AApplicationCompleteSign from '@/components/atoms/application-complete-sign';
import ABrandLogo from '@/components/atoms/brand-logo';
import AButton from '@/components/atoms/button';
import AHeading from '@/components/atoms/heading';
import AText from '@/components/atoms/text';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 't-walkthrough-complete',
  components: {
    AApplicationCompleteSign,
    ABrandLogo,
    AButton,
    AHeading,
    AText,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // handleGoToHome: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-walkthrough-complete');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleGoToHome() {
      this.updateFirstVisitFlag();
      this.$router.push({ name: 'Home' });
    },
    updateFirstVisitFlag(status = false) {
      this.postRequest('/walkthrough/update-firstVisitFlag', { status })
        .then(res => {
          if (res.status === 'success') {
            //console.log('firstVisitFlag is updated to', status);
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
  },
};
</script>
